import { combineEpics } from 'redux-observable'
import { createStreamEpic } from '../../../signalr/createStreamEpic'
import { createInvokeEpic } from '../../../signalr/createInvokeEpic'
import {
  fetchRestrictedTradesDefinition,
  saveRestrictedTradesDefinition,
  deleteRestrictedTradesDefinition
} from './definition'

export default combineEpics(
  createStreamEpic('restrictedtrades.fetch', fetchRestrictedTradesDefinition),
  createInvokeEpic(
    'restrictedtrades.saveRestrictedTrades',
    saveRestrictedTradesDefinition
  ),
  createInvokeEpic(
    'restrictedtrades.deleteRestrictedTrades',
    deleteRestrictedTradesDefinition
  )
)
